export default __webpack_public_path__ + "static/media/2233.50064287.png";